import React, { Component } from "react";
import { Link } from "react-router-dom";

import $ from "jquery/dist/jquery.js";
import * as apiConstant from "../../../api/apiConstant";
import { Businesses } from "../../../config/Helper";
import { lang } from "../../../config/lang";
import { getVideoThumbFileName } from "../../../config/utils";
import * as UTILS from "../../../config/utils";
import { setTimeout } from "timers";
import { withRouter } from "react-router-dom";
import logApi from "../../../api/logApi";
const mark = (str, keyword) => {
  const patt = new RegExp(keyword, "g");
  if (keyword !== "") {
    return str.replace(patt, `<mark>${keyword}</mark>`);
  }
  return str;
};
/****************************************
    Component for Blog Block in Blog List page
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class BlogBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
  }
  componentWillMount() {}

  componentDidMount() {
    setTimeout(this.ellipsisStyle, 600);
    window.addEventListener("resize", this.waitAndEllipsis);
  }

  componentDidUpdate() {
    setTimeout(this.ellipsisStyle, 600);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {}

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#desc_" + this.props.business + "_" + this.props.id);
  }

  onErrorImageLoad() {
    $("#img_" + this.props.business + "_" + this.props.id).attr(
      "src",
      "/assets/images/no_image.png"
    );
  }

  render() {
    return (
      <div className="single-blog-post d-flex align-items-center mb-5 ftco-animate">
        {/* {
                    (this.props.image === undefined || this.props.image === null) &&
                    <img
                        src="/assets/images/no_image.png" alt="" />
                } */}
        <div className="post-thumbnail project">
          <Link
            to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
          >
            <div className="img">
              {this.props.media_type === 0 && (
                <img
                  id={`img_${this.props.business}_${this.props.id}`}
                  onError={() => this.onErrorImageLoad()}
                  src={apiConstant.thumbnail(
                    this.props.business,
                    this.props.id,
                    this.props.image
                  )}
                  alt="blog-block"
                />
              )}
              {this.props.media_type === 1 && (
                <div>
                  <img
                    id={`img_${this.props.business}_${this.props.id}`}
                    onError={() => this.onErrorImageLoad()}
                    src={apiConstant.thumbnail(
                      this.props.business,
                      this.props.id,
                      getVideoThumbFileName(this.props.image)
                    )}
                    alt="blog-block"
                  />
                </div>
              )}
            </div>
          </Link>
          {this.props.media_type === 1 && (
            <a
              href={apiConstant.desktop(
                this.props.business,
                this.props.id,
                this.props.image
              )}
              className="play-video video-icon"
              onClick={() =>
                logApi.log({
                  title: this.props.title,
                  lang: localStorage.getItem("language"),
                  type: "동화상",
                })
              }
            >
              <i className="fa fa-play" aria-hidden="true"></i>
            </a>
          )}
        </div>

        <div className="post-content">
          <div
            className="post-meta"
            style={{
              marginLeft:
                localStorage.getItem("language") === "cn"
                  ? "21.25pt"
                  : "14.5pt",
            }}
          >
            <span
              className="post-author"
              style={{ cursor: "pointer", color: "#21ba45" }}
            >
              {UTILS.getDateString(this.props.created_at)} /{" "}
            </span>
            <span
              className="post-tutorial"
              style={{ cursor: "pointer", color: "#21ba45" }}
            >
              {lang(Businesses[this.props.business])}
            </span>
          </div>

          {/* <Link to={`/blog/${Businesses[this.props.business]}/${this.props.id}`} dangerouslySetInnerHTML={{ __html: this.props.title === undefined || this.props.title === null ? '' : this.props.title }}
                        style={{ textIndent: localStorage.getItem('language') === 'cn' ? '21.25pt' : '14.5pt' }}
                        className="post-title" /> */}
          <div
            onClick={() => {
              this.props.history.push(
                `/blog/${Businesses[this.props.business]}/${
                  this.props.id
                }?page=${this.props.currentPage}`
              );
            }}
            dangerouslySetInnerHTML={{
              __html:
                this.props.title === undefined || this.props.title === null
                  ? ""
                  : UTILS.symbolingText(this.props.title, this.props.keyword),
            }}
            className="blog-title"
          ></div>
          <div
            className="post-description ellipsis multiline"
            style={{ marginBottom: "20px" }}
            id={`desc_${this.props.business}_${this.props.id}`}
            caption={UTILS.symbolingText(this.props.description)}
            dangerouslySetInnerHTML={{
              __html:
                this.props.description === undefined ||
                this.props.description === null
                  ? ""
                  : UTILS.symbolingText(
                      this.props.description,
                      this.props.keyword
                    ),
            }}
          />
          {/* <Link to={`/blog/${Businesses[this.props.business]}/${this.props.id}`} className="btn mini btn-primary btn-outline-primary px-2 py-1">{lang('read_more')}</Link> */}
          <div
            onClick={() => {
              this.props.history.push(
                `/blog/${Businesses[this.props.business]}/${
                  this.props.id
                }?page=${this.props.currentPage}`
              );
            }}
            className="btn mini btn-primary btn-outline-primary px-2 py-1"
          >
            {lang("read_more")}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BlogBlock);
